export function getImageUrl(url) {
  if (typeof url === "string") return url

  if (typeof url === "object") return url.url

  return null
}
